<template>
  <div class="page-content">
    <div class="card row">
      <div class="card-body col-md-12">
        <b-tabs content-class="mt-3" justified>
          <b-tab title="List of Keywords" class="p-2" active>
            <div class="row d-flex align-items-center">
              <div class="col-5 col-sm-5">
                <!-- <form class="search-form" @submit.prevent="doSearch()">
                  <div class="input-group border rounded-sm">
                    <div class="input-group-prepend">
                      <div class="input-group-text border-0 rounded-sm">
                        <FeatherIcon type="search" class="icon-md cursor-pointer" />
                      </div>
                    </div>
                    <input v-model="search.search_keyword" type="text" class="form-control  border-0 rounded-sm" id="searchForm" placeholder="Search here...">
                  </div>
                </form> -->
                <div>
                  <el-input clearable @clear="doSearch()" size="small" class="input-with-select" prefix-icon="el-icon-search" placeholder="Search here..." v-model="search.search_keyword">
                    <el-select v-model="search.search_by" slot="append">
                      <el-option v-for="(val, index) in search_by_options" :key="index" :label="val.text" :value="val.value"></el-option>
                    </el-select>
                  </el-input>
                </div>
              </div>
              <div class="col-3 col-sm-3" style="margin-left: -20px;">
                <el-button type="info" size="small" @click="doSearch()">Searchs</el-button>
              </div>
              <div class="col-4 col-sm-4">
                <button class="btn btn-primary float-right" @click="$router.push('/chatbot-templates/create')">{{ $t('chatbot_template.btn_create_new') }}</button>
              </div>
            </div>
            <hr/>
            <div class="table-responsive mt-2">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Keywords</th>
                    <th>Response Type</th>
                    <th>Response Preview</th>
                    <th>Scenario</th>
                    <th>Created Date</th>
                    <th colspan="4">#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in list" :key="i">
                    <td>{{ item.title }}</td>
                    <td>
                      <el-tag size="mini" v-for="(keyword, i1) in item.keyword" :key="i1" class="mr-2">{{ keyword }}</el-tag>
                    </td>
                    <td>{{ upperFirst(item.body_type) }}</td>
                    <td>
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="hover">
                        <h6 v-if="item.header" class="mb-2">Header</h6>
                        <p v-if="item.header" class="mb-2">
                          <font-awesome :icon="item.header.icon"/>&nbsp; {{ item.header.text || item.header.type_str }}
                        </p>
                        <h6 class="mb-2">Body</h6>
                        <p class="mb-2" style="white-space: pre-line; overflow-wrap: break-word;">
                          <i class="el-icon-picture-outline" v-if="item.body_type == 'image'"/>
                          <i class="el-icon-video-camera" v-if="item.body_type == 'video'"/>
                          <i class="el-icon-document" v-if="item.body_type == 'document'"/>
                          <span>
                            {{ ['text', 'interactive'].includes(item.body_type) ? item.body : item.caption }}
                          </span>
                        </p>
                        <template v-if="item.footer && item.footer.text">
                          <h6 class="mb-2">Footer</h6>
                          <p class="mb-2" style="white-space: pre-line; overflow-wrap: break-word;">{{ item.footer.text }}</p>
                        </template>
                        <h6 v-if="item.button_content_mapped" class="mb-2">Buttons</h6>
                        <p class="mb-2">
                          <span v-for="(btn, ibtn) in item.button_content_mapped" :key="ibtn">
                            <font-awesome :icon="btn.icon"/>&nbsp; {{ btn.text }} ({{btn.type_str}})<br/>
                          </span>
                        </p>
                        <h6 v-if="item.list_content_mapped" class="mb-2">List</h6>
                        <p class="mb-2">
                          <span v-for="(btn, ibtn) in item.list_content_mapped" :key="ibtn">
                            <font-awesome :icon="btn.icon"/>&nbsp; {{ btn.text }}<br/>
                          </span>
                        </p>
                        <span @click="visible = !visible" slot="reference" style="padding: 6px">
                          {{ truncate(['text', 'interactive'].includes(item.body_type) ? item.body : item.caption, 35) }}
                        </span>
                      </el-popover>
                    </td>
                    <td>{{ item.scenario_type == 'cs' ? 'Customer Service' : 'Normal' }}</td>
                    <td>{{ item.created_at_str }}</td>
                    <td>
                      <div class="d-flex align-items-end">
                        <button class="btn btn-outline-primary btn-sm" @click="handlerBtnEdit(item.id)">
                          <i class="ic-edit" />
                        </button> &nbsp;
                        <button class="btn btn-outline-primary btn-sm" @click="handlerBtnDelete(item.id)">
                          <i class="ic-delete" />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <el-empty :image="emptyBot" v-if="total == 0" description="No chatbot templates"></el-empty>
              <b-pagination v-if="total > search.per_page" v-model="currentPage" :total-rows="total" :per-page="search.per_page"/>
            </div>
          </b-tab>
          <b-tab title="Keywords Analytics" class="p-2">
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                    <div class="row mb-3">
                      <div class="col-md-12">
                        <h5 class="mb-3">Chatbot keyword overview in</h5>
                        <el-date-picker
                          v-model="filter.date_range"
                          type="daterange"
                          size="small"
                          :picker-options="date_picker_options"
                          @change="dateCheck"
                          range-separator="To"
                          start-placeholder="Start date"
                          end-placeholder="End date">
                        </el-date-picker>
                      </div>
                    </div>
                    <div class="row chart-by mb-2">
                      <div class="col-md-3">
                        <div class="card">
                          <div class="card-body" v-loading="loading.channel" style="min-height: 200px;">
                            <div class="card-head mb-5">
                              <h5 class="float-left">Channel usage</h5>
                            </div>
                            <apexchart v-if="!isEmpty(channel_chart_options.series.filter(v => v > 0))" :options="channel_chart_options" :series="channel_chart_options.series"></apexchart>
                            <div v-else class="d-flex justify-content-center align-items-center w-100">
                              <el-empty description="No data"></el-empty>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-9">
                        <div class="card">
                          <div class="card-body" v-loading="loading.top_ten_title" style="min-height: 200px;">
                            <div class="card-head mb-3">
                              <h5 class="float-left">Top ten keywords usage</h5>
                            </div>
                            <apexchart ref="top_ten_title_chart" height="270px" :options="top_ten_title_chart_options" :series="top_ten_title_chart_options.series"></apexchart>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-sm-6 my-2">
                        <h5 class="mb-3">Analytic chatbot keywords</h5>
                        <el-select filterable remote reserve-keyword @change="onChangeFilterKeywords" clearable :filter-method="handlerFilterKeywords" class="w-100" size="small" placeholder="Choose Keywords Label" v-model="filter_analytics.search_keyword">
                          <el-option
                            v-for="item in keywords_list_filter"
                            :key="item.id"
                            :value="item.id"
                            :label="item.title"
                          >
                            {{ item.title }}
                          </el-option>
                        </el-select>
                      </div>
                      <div class="col-sm-6"></div>
                      <div class="col-md-12">
                        <div class="card">
                          <div class="card-body" v-loading="loading.keyword_chart" style="min-height: 380px;">
                            <div class="card-head mb-3">
                              <h5 class="float-left">Keywords Usage</h5>
                            </div>
                            <apexchart ref="keyword_chart" height="300" :options="keyword_chart_options" :series="keyword_chart_options.series"></apexchart>
                          </div>
                        </div>
                      </div>
                      <div v-if="filter_analytics.search_keyword !== ''" class="col-md-12">
                        <div class="card mt-3">
                          <div class="card-body" v-loading="loading.top_ten" style="min-height: 200px;">
                            <div class="card-head mb-3">
                              <h5 class="float-left">Top ten keywords</h5>
                            </div>
                            <apexchart ref="top_ten_chart" height="270px" :options="top_ten_chart_options" :series="top_ten_chart_options.series"></apexchart>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import emptyBot from '@/assets/images/undraw/no-bot.svg';
import moment from 'moment';
import {
  upperFirst, isEqual, uniqBy, isEmpty, startCase,
} from 'lodash';
import chatbotTemplates from '../../../api/chatbotTemplates';
import analyticApi from '../../../api/analytics';
import popupErrorMessages from '../../../library/popup-error-messages';

export default {
  beforeCreate() {
    this.isEmpty = isEmpty;
  },
  metaInfo: {
    title: 'Chatbot Templates',
  },
  name: 'ChatbotTemplateIndex',
  data() {
    return {
      emptyBot,
      upperFirst,
      search: {
        page: this.$route.query.page || 1,
        per_page: this.$route.query.per_page || 10,
        search_keyword: this.$route.query.search_keyword || '',
        search_by: this.$route.query.search_by || 'title',
      },
      search_by_options: [
        {
          text: 'Title',
          value: 'title',
        },
        {
          text: 'Keywords',
          value: 'keyword',
        },
        {
          text: 'Message',
          value: 'body',
        },
      ],
      list: [],
      keywords_list: [],
      keywords_list_filter: [],
      analytic_keywords_list: [],
      total: 0,
      loading: {
        channel: false,
        top_ten: false,
        top_ten_title: false,
        keyword_chart: false,
      },
      filter_analytics: {
        search_keyword: '',
        search_by: 'keyword_id',
      },
      channel_chart_options: {
        chart: {
          type: 'pie',
        },
        stroke: {
          colors: ['rgba(0,0,0,0)'],
        },
        tooltip: {
          fixed: {
            enabled: true,
          },
        },
        labels: [],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          enabled: true,
        },
        series: [],
      },
      top_ten_chart_options: {
        series: [
          {
            name: 'Keyword Usage',
            data: [],
          },
        ],
        colors: ['#26A65B'],
        chart: {
          height: 250,
          type: 'bar',
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
        },
        fill: {
          opacity: 5,
        },
        tooltip: {
          y: {
            formatter: (val) => val.toLocaleString('id-ID'),
          },
        },
      },
      top_ten_title_chart_options: {
        series: [
          {
            name: 'Keyword Usage',
            data: [],
          },
        ],
        colors: ['#26A65B'],
        chart: {
          height: 250,
          type: 'bar',
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
        },
        fill: {
          opacity: 5,
        },
        tooltip: {
          y: {
            formatter: (val) => val.toLocaleString('id-ID'),
          },
        },
      },
      keyword_chart_options: {
        series: [],
        colors: [],
        chart: {
          height: 250,
          type: 'area',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1, 1, 1],
          curve: 'smooth',
        },
        xaxis: {},
        yaxis: {
          min: 0,
          title: {
            text: 'Total used keywords',
          },
        },
        fill: {
          opacity: 5,
        },
        tooltip: {
          shared: true,
          y: {
            formatter: (val) => val.toLocaleString('id-ID'),
          },
        },
      },
      filter: {
        date_type: 'this_month',
        date_range: [
          moment().subtract(7, 'days').format(),
          moment().format(),
        ],
      },
      date_picker_options: {
        disabledDate: (time) => {
          const today = moment();
          const diff = today.diff(moment(time), 'd');
          const cutoff = new Date(2025, 8, 1); // Only possible select from september 1, 2025
          if (time < cutoff) {
            return true;
          }
          if (diff > 90 || diff < 0) {
            return true;
          }
          if (diff === 0 && today.isSame(moment(time), 'd') === false) {
            return true;
          }
          return false;
        },
        shortcuts: [
          {
            text: 'Today',
            onClick(picker) {
              const start = moment().startOf('day').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'This week',
            onClick(picker) {
              const start = moment().startOf('week').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'This month',
            onClick(picker) {
              const start = moment().startOf('month').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last week',
            onClick(picker) {
              const start = moment().subtract(1, 'week').startOf('week').format();
              const end = moment().subtract(1, 'week').endOf('week').format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const start = moment().subtract(1, 'month').startOf('month').format();
              const end = moment().subtract(1, 'month').endOf('month').format();
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getList();
    this.getAllKeywords();
    this.getSummaryChatbotTitle();
    this.getChatbotKeywordCharts();
    this.getChannelAnalytic();
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    currentPage: {
      get() {
        return this.search.page;
      },
      set(val) {
        this.search.page = val;
        this.getList();
      },
    },
  },
  methods: {
    async getAllKeywords() {
      const { data } = await chatbotTemplates.getAll({
        workspace_id: this.activeWorkspace._id,
        query: this.filter_analytics,
      });
      this.keywords_list = data;
      this.keywords_list_filter = data;
    },
    onChangeFilterKeywords() {
      this.getSummaryChatbotKeywords();
      this.getChatbotKeywordCharts();
    },
    handlerFilterKeywords(keyword) {
      setTimeout(() => {
        if (keyword) {
          this.keywords_list_filter = this.keywords_list.filter(
            (v) => v.title.toLowerCase().includes(keyword.toLowerCase())
              && this.analytic_keywords_list.includes(v.id),
          );
        } else {
          this.keywords_list_filter = this.keywords_list.filter((v) => this.analytic_keywords_list.includes(v.id));
        }
      }, 500);
    },
    dateCheck() {
      const [start_date, end_date] = this.filter.date_range;
      const minTime = moment(start_date);
      const maxTime = moment(end_date);
      const diff = maxTime.diff(moment(minTime), 'd');
      if (diff > 30) {
        this.$message({
          title: this.$t('general.error.general'),
          type: 'warning',
          message: 'Reporting period that can be selected for 31 days',
          duration: 20 * 100,
          showClose: true,
        });
        this.filter.date_range = [start_date, start_date];
      }
      this.getSummaryChatbotKeywords();
      this.getSummaryChatbotTitle();
      this.getChatbotKeywordCharts();
      this.getChannelAnalytic();
    },
    truncate(str, length) {
      return str ? `${str.substring(0, length || 20)}...` : '';
    },
    async getList() {
      const options = {
        page: this.search.page.toString(),
        per_page: this.search.per_page.toString(),
        search_keyword: this.search.search_keyword,
        search_by: this.search.search_by,
      };
      if (!isEqual(options, this.$route.query)) {
        this.$router.replace({ query: options });
      }
      this.$parent.showLoader();
      const { data } = await chatbotTemplates.getList({
        workspace_id: this.activeWorkspace._id,
        query: options,
      });
      this.list = data.rows.map((v) => {
        v.created_at_str = moment(v.created_at).format('DD MMM YYYY, HH:mm');
        if (v.body_type === 'interactive' && v.action) {
          if (v.action_type === 'button') {
            v.button_content_mapped = v.action.buttons.map((btn) => {
              btn.type_str = 'Quick Reply';
              btn.text = btn.reply.title;
              btn.icon = 'comment';
              return btn;
            });
          }
          if (v.action_type === 'list') {
            v.list_content_mapped = v.action.sections[0].rows.map((list) => {
              list.text = list.title;
              if (list.description) {
                list.text += ` (${list.description})`;
              }
              list.icon = 'list';
              return list;
            });
          }
        }
        if (v.header) {
          v.header.type_str = upperFirst(v.header.type.toLowerCase());
          v.header.icon = v.header.type_str.toLowerCase();
          if (v.header.type_str.toLowerCase() === 'document') {
            v.header.icon = 'file-alt';
          } else if (v.header.type_str.toLowerCase() === 'text') {
            v.header.icon = 'paragraph';
          }
        }
        return v;
      });
      this.total = data.total;
      this.$parent.hideLoader();
    },
    doSearch() {
      this.search.page = 1;
      this.getList();
    },
    handlerBtnEdit(id) {
      this.$router.push({
        name: 'Chatbot Templates - Edit',
        params: {
          id,
        },
      });
    },
    handlerBtnDelete(id) {
      this.$confirm(this.$t('chatbot_template.confirm_delete'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;

            const response = await chatbotTemplates.delete({ id, workspace_id: this.activeWorkspace._id })
              .catch(() => {});
            instance.confirmButtonLoading = false;
            await popupErrorMessages(response);

            this.$message({
              message: this.$t('chatbot_template.success_delete'),
              type: 'success',
            });
            this.getList();
            cb();
            return;
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
    async getChannelAnalytic() {
      this.loading.channel = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const response = await analyticApi.chatbotKeywordChannels({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      await popupErrorMessages(response);
      this.renderChannel(response.data);
    },
    async getSummaryChatbotKeywords() {
      this.loading.top_ten = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      this.top_ten_chart_options.series[0].data = [];
      this.top_ten_chart_options.xaxis.categories = [];
      const response = await analyticApi.summaryChatbotKeywords({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
        search_by: this.filter_analytics.search_by,
        search_keyword: this.filter_analytics.search_keyword,
      });
      await popupErrorMessages(response);
      if (response.data.length > 0) {
        this.top_ten_chart_options.xaxis.categories = response.data.map((v) => v.title);
        this.top_ten_chart_options.series[0].data = response.data.map((v) => v.total);
      }
      if (this.$refs.top_ten_chart) await this.$refs.top_ten_chart.refresh();
      this.loading.top_ten = false;
    },
    async getSummaryChatbotTitle() {
      this.loading.top_ten_title = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      this.top_ten_title_chart_options.series[0].data = [];
      this.top_ten_title_chart_options.xaxis.categories = [];
      const response = await analyticApi.summaryChatbotTitleKeywords({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
      });
      await popupErrorMessages(response);
      if (response.data.length > 0) {
        const categories = response.data.map((v) => v.title);
        const seriesData = response.data.map((v) => v.total);
        this.top_ten_title_chart_options = {
          ...this.top_ten_title_chart_options,
          xaxis: {
            ...this.top_ten_title_chart_options.xaxis,
            categories: [...categories],
          },
          series: [
            {
              ...this.top_ten_title_chart_options.series[0],
              data: [...seriesData],
            },
          ],
        };
      }
      if (this.$refs.top_ten_title_chart) await this.$refs.top_ten_title_chart.refresh();
      this.loading.top_ten_title = false;
    },
    async getChatbotKeywordCharts() {
      this.loading.keyword_chart = true;
      const start_date = this.filter.date_range[0] || moment().format();
      const end_date = this.filter.date_range[1] || moment().format();
      const start_day = moment(start_date).startOf('day');
      const end_day = moment(end_date).endOf('day');
      const gapDays = end_day.diff(start_day, 'days');
      let labels = {
        format: 'dd MMM',
        showDuplicates: false,
        hideOverlappingLabels: false,
      };
      if (gapDays === 30) {
        labels = {
          formatter(value) {
            return moment(value).format('D MMM');
          },
          showDuplicates: false,
          hideOverlappingLabels: false,
        };
      }
      this.keyword_chart_options.xaxis = {
        type: 'datetime',
        min: new Date(start_day).getTime(),
        max: new Date(end_day).getTime(),
        tickAmount: gapDays,
        labels,
      };
      if (moment(end_date).isAfter(moment(), 'day')) {
        this.keyword_chart_options.xaxis.max = new Date(moment().startOf('day')).getTime();
      }
      const response = await analyticApi.chatbotKeywordCharts({
        workspace_id: this.activeWorkspace._id,
        start_date,
        end_date,
        search_by: this.filter_analytics.search_by,
        search_keyword: this.filter_analytics.search_keyword,
      });
      await popupErrorMessages(response);
      this.keyword_chart_options.series = [];
      if (!response.error) {
        if (response.data && Object.keys(response.data).length) {
          const hashCategoryDate = new Map();
          Object.entries(response.data).forEach(([key, value]) => {
            if (!hashCategoryDate.has(key)) {
              hashCategoryDate.set(key, {});
            }
            const keyDate = hashCategoryDate.get(key);
            keyDate.id = value.id;
            value.data.forEach((v) => {
              const dataDate = new Date(moment(v.date).format('YYYY-MM-DD')).getTime();
              if (!keyDate.date) {
                keyDate[dataDate] = [];
              }
              keyDate[dataDate].push(parseInt(v.total_keyword));
            });
          });
          hashCategoryDate.forEach((value, key) => {
            const tempSeries = {
              name: upperFirst(key),
              data: [],
            };
            const hashDateTotalCount = {};
            Object.entries(value).forEach(([key_keyword, value_keyword]) => {
              if (Array.isArray(value_keyword)) {
                const dateStr = moment(parseInt(key_keyword)).format('YYYY-MM-DD');
                hashDateTotalCount[dateStr] = value_keyword[0];
              } else {
                tempSeries.id = value_keyword;
              }
            });
            const current = start_day.clone();
            while (current.isSameOrBefore(end_day)) {
              const dateStr = current.format('YYYY-MM-DD');
              const timestamp = new Date(moment(current).format('YYYY-MM-DD')).getTime();
              const total = hashDateTotalCount[dateStr] || 0;
              tempSeries.data.push([timestamp, total]);
              current.add(1, 'day');
            }
            this.keyword_chart_options.colors.push(this.getRandomColor());
            this.keyword_chart_options.series.push(tempSeries);
          });
        }
        if (!this.filter_analytics.search_keyword) {
          this.analytic_keywords_list = this.keyword_chart_options.series.map((v) => v.id);
          this.keywords_list_filter = this.keywords_list.filter((v) => this.analytic_keywords_list.includes(v.id));
        }
      }
      if (this.$refs.keyword_chart) await this.$refs.keyword_chart.refresh();
      this.loading.keyword_chart = false;
    },
    renderChannel(data = []) {
      const color = {
        whatsapp: '#26A65B',
        telegram: 'rgb(100, 187, 228)',
        sms: '#81d2d3',
      };
      data = uniqBy(data, 'channel_name');
      this.channel_chart_options = {
        ...this.channel_chart_options,
        series: data.map((v) => parseInt(v.count)),
        labels: data.map((v) => this.formatChannelName(v.channel_name)),
        colors: data.map((v) => color[v.channel_name.toLowerCase()]),
      };
      this.loading.channel = false;
    },
    getRandomColor() {
      const color = Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
      return `#${color}`;
    },
    formatChannelName(text) {
      return startCase(text);
    },
  },
};
</script>
<style>
.el-select .el-input {
  min-width: 110px;
}
.input-with-select .el-input-group__append {
  background-color: #fff;
}
</style>
